import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SwiperComponent } from 'swiper/angular';
import Swiper from 'swiper';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, catchError, from, map, of, throwError } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
declare var bootstrap: any;
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements AfterViewInit, OnInit {
  showModal: boolean = false;
   cityCountRecords: any[] = []; // Stores the list of all popular cities/localities (for tabs)
  landmarkCountRecords: any[] = []; // Sub-localities/landmarks for the selected city

  // === Search/Filter State ===
  searchWhereActual: any = { 
    city: null, // Holds the selected city NAME (e.g., 'Ambi')
    city_id: null, // Holds the selected city ID
    landmark: null,
    property_type_id: null,
  };
  // First Set of Dropdowns
  emirates = configuration.EMIRATES;
  devloperForm: FormGroup;
  isSubmitted = false;
  successMessage: string = '';
  errorMessage: string = '';
  message: string = '';
  priceLimitSelectedOption: string = '';
  rentSelectedOption: string = '';
  bedroomselectedOption: string = '';
  selectedOption: string = '';
  isDropdownOpen: boolean = false;
  isPriceLimitrentDropdownOpen: boolean = false;
  isRentDropdownOpen: boolean = false;
  propertyTypes: string[] = ['Apartment', 'Townhouse', 'Villa'];
  bedroomnumber: string[] = ['1', '2', '3', '4', '5', '6', '7', '7+'];
  // Second Set of Dropdowns
  priceLimitselectedOption: string = '';
  isPriceLimitDropdownOpen: boolean = false;
  isBedroomDropdownOpen: boolean = false;
  priceLimit: string[] = ['100 AED', '10,000 AED', '50,000 AED'];
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;
  renderer: any;
  elRef: any;
  sliderItems = [
    { image: "assets/images/img-1.png", city: "Dubai" },
    { image: "assets/images/img-10.png", city: "Abu Dhabi" },
    { image: "assets/images/img-11.png", city: "Sharjah" },
    { image: "assets/images/img-4.png", city: "Ras Al Khaimah" },
    { image: "assets/images/img-5.png", city: "Ajman" },
    { image: "assets/images/img-6.png", city: "Umm Al Quwain" },
    { image: "assets/images/img-7.png", city: "Fujairah" },
  ]

  sliderItems02 = [
    { image: "assets/images/property.jpeg", property_name: "Damac Hills 1" },
    { image: "assets/images/property01.jpeg", property_name: "Autograph Collection By Damac" },
    { image: "assets/images/property03.webp", property_name: "Nad Al Sheba Gardens Phase 3" },
    { image: "assets/images/property04.jpeg", property_name: "Damac Natura" },
    { image: "assets/images/property05.webp", property_name: "Liv Lux" },
  ]
  mortgagesForm: any;
  cityData: any = []
  tempCityData: any = []
  searchTerm: any = '';
  showOptions: boolean = false;
  searchCityId: any = '';
  tagValues: { label: any, value: any }[] = [];
  selectedTagItems : any = [];
  selling_type : any = 'buy'
  contact_type : any = ''
  CLOUDFRONT_URL = environment.CLOUDFRONT_URL;
  inputValue: any;
  options: any;
  // items = ['Pizza', 'Pasta', 'Parmesan'];
  // itemsAsObjects = [{value: 0, display: 'Angular'}, {value: 1, display: 'React'}];
  lastSearch = "";
  lastSearchData = [];
  minPrice : any =''
  maxPrice : any =''
  developerData: any[] = []; // Ensure to type this appropriately
  reviewData: any[] = [];
  podcasts: any[] = []; // Store the entire list of podcasts
  isLoading = true;
  isBudgetDropdownOpen = false;
  priceOptions: string[] = [
    '20 Lac', '25 Lac', '30 Lac', '35 Lac', '40 Lac',
    '45 Lac', '50 Lac', '60 Lac', '70 Lac', '80 Lac',
    '90 Lac', '1 Cr', '1.5 Cr', '2 Cr', '3 Cr', '5 Cr'
  ];
  isMyProperty: any;

  clearAll() {
    this.minPrice = '';
    this.maxPrice = '';
  }
  budgetToggleDropdown() {
  this.isBudgetDropdownOpen = !this.isBudgetDropdownOpen;
}
  @ViewChild(SwiperComponent) swiperComponent?: SwiperComponent;
  @ViewChild('swiperContainer') swiperContainer!: ElementRef;
  isBrowser = false;

  swiperOptions: SwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 50,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };

  getCityUrl(city: string): string {
    return 'properties/city/' + city.split(' ').join('%20');
  }
  
  public swiperOp: SwiperOptions = {
    slidesPerView: 3,
    direction: 'horizontal',
    navigation: true,
    hashNavigation: true,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax:true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20, // Optionally, you can adjust the space between slides for mobile
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20, // Optionally, you can adjust the space between slides for mobile
      },
    }
  };

  public swiperReview: SwiperOptions = {
    slidesPerView: 1,
    direction: 'horizontal',
    navigation: true,
    hashNavigation: true,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax:true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 20, // Optionally, you can adjust the space between slides for mobile
      },
    }
  };

  constructor(public shared: SharedService, private apiService: ApiServiceService, private fb: FormBuilder, private router: Router, private sanitizer: DomSanitizer) {
    this.devloperForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      project_name: ['', Validators.required],
      devloper_name: ['', Validators.required],
      emirates: ['', Validators.required],
    });
    this.shared.isWhiteMenu = false;
  }


  
  ngOnInit(): void {
    this.isBrowser = this.shared.isBrowser();
    if(this.renderer) {
      this.renderer.listen('document', 'click', (event: Event) => {
        const target = event.target as HTMLElement;
        if (!this.elRef.nativeElement.contains(target)) {
          this.isDropdownOpen = false;
          this.isPriceLimitDropdownOpen = false;
          this.isBedroomDropdownOpen = false;
          this.isRentDropdownOpen = false;
        }
      });
    }
    this.shared.setSEOData("Direkt | Buy and Rent Real Estate in UAE", {
      description: "Direkt | Buy and Rent Real Estate in UAE",
      url: environment.DOMAIN
    })
    this.getPropertyList();
    this.getCityList();
    this.getData();
    this.getHomepagePodcast()
   // Show the modal on page load
  //  const myModal = new bootstrap.Modal(document.getElementById('pageLoadeModal'), {
  //   backdrop: 'static', // Prevent closing on outside click
  //   keyboard: false // Prevent closing with Esc key
  // });
  // myModal.show();
}
async getHomepagePodcast() {
 
    const url = configuration.ENDPOINT.GET_HOMEPAGE_PODCAST; 
    const response = await this.apiService.POST_apiRequest(
      url,
      {}, 
    );

    if (response && !response.error && response.data) {
      this.isLoading = false;
      this.podcasts = response.data.map((podcast: any) => {
        let cleanName = (podcast.name || '').trim().replace(/\s+/g, ' ');
        let truncatedName = cleanName.length > 30 ? cleanName.substring(0, 30) + '...' : cleanName; 
    
        return {
          ...podcast,
          safeIframeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(podcast.iframe_code),
          truncatedName: truncatedName 
        };
      });
    
      console.log('Final Podcasts Array:', this.podcasts);
    } else {
      console.error('Failed to load podcasts:', response.message);
    }
    
    
    
  }    


  ngAfterViewInit(): void {
    // Initialize swiper after the view is initialized
    if(this.swiperContainer){
      const swiper = new Swiper(this.swiperContainer.nativeElement, {
        // Add your swiper options here
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        // Add navigation buttons
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
    var self = this;
    if( this.shared.isBrowser()) {
      document.addEventListener("DOMContentLoaded", function() {
        var video:any = document.getElementById("myVideo");
        video.muted = true; // Mute the video
        video.play().catch((error:any) => console.error("Error attempting to play video:", error));
        // self.shared.enablePopoverScript();
        let optionsPopover;
        const popoverPriceMainDiv = document.getElementById('popoverPriceMainDiv');
        const popoverTriggerEl = document.getElementById('popoverButton');
        if (popoverTriggerEl) {
          const popover = new bootstrap.Popover(popoverTriggerEl, {
            html: true, // Allows HTML content
            customClass: 'price-popover-box',
            container: "#popoverPriceMainDiv1",
            content: () => {
              // Define your custom HTML content here
              const divElement = document.createElement('div');
              divElement.innerHTML = `
              <div class='row'  style='width:400px'>
                <div class='col-6'>
                  <input type='text' id='popoverButtonMinPrice' value='${self.minPrice}' class='form-control' placeholder='Min Price' data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" />
                </div>
                <div class='col-6'>
                  <input type='text' id='popoverButtonMaxPrice' value='${self.maxPrice}' class='form-control' placeholder='Max Price' data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" />
                </div>
                <div class='col-6 mt-2'>
                  <p  class='pointer price-box-buttons'id="resetFilter">Reset Filter</p>
                </div>
                <div class='col-6 mt-2'>
                  <p  class='pointer price-box-buttons'id="closeFilter">Close Filter</p>
                </div>
              </div>
              `;
              return divElement;
            }
          });
  
  
          const searchButton = document.getElementById('search');
            if (searchButton) {
              searchButton.addEventListener('click', () => {
                popover.hide(); // Hide the popover
              });
              if (optionsPopover) {
                optionsPopover.hide(); // Hide the options popover
              }
            }
  
          popoverTriggerEl.addEventListener('shown.bs.popover', () => {
  
            const resetFilterButton = document.getElementById('resetFilter');
            if (resetFilterButton) {
              resetFilterButton.addEventListener('click', () => {
                self.minPrice = '';
                self.maxPrice = '';
                const minPriceInput = document.getElementById('popoverButtonMinPrice') as HTMLInputElement;
                const maxPriceInput = document.getElementById('popoverButtonMaxPrice') as HTMLInputElement;
                minPriceInput.value = '';
                maxPriceInput.value = '';
                if (optionsPopover) {
                  optionsPopover.hide(); // Hide the options popover
                }
              });
            }
  
            const closeFilterButton = document.getElementById('closeFilter');
            if (closeFilterButton) {
              closeFilterButton.addEventListener('click', () => {
                popover.hide(); // Hide the popover
                if (optionsPopover) {
                  optionsPopover.hide(); // Hide the options popover
                }
              });
            }
  
            // Add event listener to close options when clicking outside
            document.addEventListener('click', (event: any) => {
              if (!popoverTriggerEl.contains(event.target)) {
                if (optionsPopover) {
                  optionsPopover.hide(); // Hide the options popover
                }           
              }
              if (!popoverPriceMainDiv.contains(event.target)) {
                if (popover) {
                  popover.hide(); // Hide the options popover
                }
              }
            });
      
            const popoverTriggerEl2 : any = document.getElementById('popoverButtonMinPrice');
            if (popoverTriggerEl2) {
              const popover2 = new bootstrap.Popover(popoverTriggerEl2, {
                html: true, // Allows HTML content
                placement: "bottom",
                customClass: 'price-options-popover-box',
                container: "#popoverPriceMainDiv2",
                content: () => {
                  let optionsDiv = ``
                  let minPrice = 300000;
                  while(minPrice < 50000000) {
                    optionsDiv += `
                    <div class='eachOptionMin'>${minPrice} AED</div>
                    `
                    minPrice += 100000
                  }
                  // Define your custom HTML content here
                  const divElement = document.createElement('div');
                  divElement.innerHTML = `
                  <div class="col-12 bg-white">
                      <div class="form-group">
                          <div class="form-field">
                              <div class="select-wrap">
                                  <div class="custom-dropdown">
                                      <div class="options">
                                          ${optionsDiv}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  `;
                  return divElement;
                }
              });
  
              popoverTriggerEl2.addEventListener('shown.bs.popover', () => {
                optionsPopover = popover2;
                $(".price-options-popover-box").find(".eachOptionMin").click(function() {
                  self.minPrice = parseInt($(this).html());
                  $("#popoverButtonMinPrice").val(self.minPrice);
                  popover2.hide();
                });
              });
            }
  
            const popoverTriggerEl3 : any = document.getElementById('popoverButtonMaxPrice');
            if (popoverTriggerEl3) {
              const popover2 = new bootstrap.Popover(popoverTriggerEl3, {
                html: true, // Allows HTML content
                customClass: 'price-options-popover-box',
                container: "#popoverPriceMainDiv3",
                content: () => {
                  // Define your custom HTML content here
                  let optionsDiv = ``
                  let minPrice = (self.minPrice ? self.minPrice : 300000);
                  while(minPrice < 50000000) {
                    optionsDiv += `
                    <div class='eachOptionMax'>${minPrice} AED</div>
                    `
                    minPrice += 100000
                  }
                  // Define your custom HTML content here
                  const divElement = document.createElement('div');
                  divElement.innerHTML = `
                  <div class="col-12 bg-white">
                      <div class="form-group">
                          <div class="form-field">
                              <div class="select-wrap">
                                  <div class="custom-dropdown">
                                      <div class="options">
                                          ${optionsDiv}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  `;
                  return divElement;
                }
              });
  
              popoverTriggerEl3.addEventListener('shown.bs.popover', () => {
                optionsPopover = popover2;
                $(".price-options-popover-box").find(".eachOptionMax").click(function() {
                  self.maxPrice = parseInt($(this).html());
                  $("#popoverButtonMaxPrice").val(self.maxPrice);
                  popover2.hide();
                });
              });
            }
  
            popoverTriggerEl2.addEventListener('input', () => {
              self.minPrice = popoverTriggerEl2.value;
              // console.log('Min Price:', self.minPrice);
            });
            
            // Event listener to get the max price
            popoverTriggerEl3.addEventListener('input', () => {
              self.maxPrice = popoverTriggerEl3.value;
              // console.log('Max Price:', self.maxPrice);
            });
      
          });
        }
  
        // document.addEventListener('click', function (event) {
        //   let target = event.target;
        //   let popover = document.querySelector('.popover'); // Select the popover HTML element
          
        //   if (popover) {
        //     let isClickInsidePopover = target instanceof Node && popover.contains(target) ;
        //     let isClickInsidePopoverTrigger = target instanceof Node && popoverTriggerEl.contains(target);
        
        //     if (!isClickInsidePopover && !isClickInsidePopoverTrigger) {
        //       // This is a click outside both elements, hide the popover
        //       bootstrap.Popover.getInstance(popoverTriggerEl).hide();
        //     }
        //   }
        // });
      });
    }

  }

  // Methods for the First Set of Dropdowns
  onDocumentClick(event: MouseEvent) {
    const dropdown: any = document.querySelector('.custom-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleRentDropdown(): void {
    this.isRentDropdownOpen = !this.isRentDropdownOpen;
  }

  toggleRentPriceLimitDropdown(): void {
    this.isPriceLimitrentDropdownOpen = !this.isPriceLimitrentDropdownOpen ;
  }
  selectPriceLimitOption(option: string): void {
    this.priceLimitSelectedOption = option;
    this.isPriceLimitrentDropdownOpen = false;
  }

  bedroomtoggleDropdown(): void {
    this.isBedroomDropdownOpen = !this.isBedroomDropdownOpen;
  }

  selectOption(option: string): void {
    this.selectedOption = option;
    this.isDropdownOpen = false;
  }
  
  selectRentOption(option: string): void {
    this.rentSelectedOption = option;
    this.isRentDropdownOpen = false;
  }

  bedrooomselectOption(option: string): void {
    this.bedroomselectedOption = option;
    this.isBedroomDropdownOpen = false;
    console.log("isBedroomDropdownOpen", this.isBedroomDropdownOpen);
  }

  // Methods for the Second Set of Dropdowns
  onbedroomDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.bedroom-number-dropdown');
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.isBedroomDropdownOpen = false;
    }
  }


  onRentDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.rent-dropdown');
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.isRentDropdownOpen = false;
    }
  }

  onRentpriceDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.rent-dropdown');
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.isPriceLimitrentDropdownOpen = false;
    }
  }
  onPriceLimitDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.price-limit-dropdown');
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.isPriceLimitDropdownOpen = false;
    }
  }

  priceLimitToggleDropdown(): void {
    this.isPriceLimitDropdownOpen = !this.isPriceLimitDropdownOpen;
  }

  priceLimitSelectOption(option: string): void {
    this.priceLimitselectedOption = option;
    this.isPriceLimitDropdownOpen = false;
  }

 async getPropertyList() {
     let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, {
      limit: this.limit,
      offset: this.offset
    });
    if (res && !res.error && res.data) {
      this.propertyList = res.data.rows;
    }
   
}

  async getCityList(){
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.CITY_LIST);
    if(res && !res.error && res.data && res.data.rows){
      this.tempCityData = res.data.rows
      this.cityData = res.data.rows // This array will populate the tabs
    }
  }
  
  // Handle the click on a city tab
  selectCity(city: any): void {
    const cityName = city.city_name;
    const cityId = city.id;

    if (this.searchWhereActual.city === cityName) return;

    // 1. Update the selected city details
    this.searchWhereActual.city = cityName;
    this.searchWhereActual.city_id = cityId;
    this.searchWhereActual.landmark = null;
    
    // 2. Reset and fetch data for the new city
    this.offset = 0;
    this.propertyList = [];
    this.landmarkCountRecords = [];
    
    this.getPropertyList();
  }


  onInputChange(event: any) {
    const value = event.target.value;
    // console.log("value",value)
    this.cityData = this.tempCityData.filter((option :any)=> option.city_name.toLowerCase().includes(value.toLowerCase()));
    this.showOptions = !!value;
  }

  selectOptionCity(data: any) {
    // console.log("data",data)
    this.searchTerm = data.city_name;
    this.searchCityId = data.id
    this.showOptions = false;
  }

  onSlideChange() {
    console.log('slide change');
  }
  
  onClick() {
    if (this.mortgagesForm.valid) {
      this.apiService.POST_apiRequest(configuration.ENDPOINT.MORTAGAGE_ADD, this.mortgagesForm.value)
        .then(res => {
          if (res && !res.error) {
            this.isSubmitted = true;
            this.message = 'Our mortgage advisor will get in touch with you soon.';
          } else {
            console.error("Error submitting the form:", res);
            this.message = 'Error submitting the form. Please try again.';
          }
        })
        .catch(error => {
          console.error("An error occurred during form submission:", error);
          this.message = 'An error occurred during form submission. Please try again.';
        });
    }
  }

  onModalClose() {
    this.isSubmitted = false;
    this.message = '';
    this.mortgagesForm.reset();
  }

  async onDone() {
    if (this.devloperForm.valid) {
      let city: any;
      if(this.devloperForm.value.emirates){
         city = this.devloperForm.value.emirates.split('_')
      }
      let json = {
        name: this.devloperForm.value.name,
        email: this.devloperForm.value.email,
        phone: this.devloperForm.value.mobile,
        project_name: this.devloperForm.value.project_name,
        developer_name: this.devloperForm.value.devloper_name,
        city_id: city[0],
        city_name : city[1]
      }
      await this.apiService.POST_apiRequest(configuration.ENDPOINT.ASSISTED_PLANS, json)
        .then(res => {
          if (res && !res.error) {
            this.isSubmitted = true;
            this.message = 'Our team will get in touch with you.';
          } else {
            console.error("Error submitting the form:", res);
            this.message = 'Error submitting the form. Please try again.';
          }
        })
        .catch(error => {
          console.error("An error occurred during form submission:", error);
          this.message = 'An error occurred during form submission. Please try again.';
        });
    }
  }
  onDevlopeModalClose() {
    this.isSubmitted = false;
    this.message = '';
    this.devloperForm.reset();
  }

  onSearch() {
    // console.log("min",this.minPrice)
    // console.log("max",this.maxPrice)
    // // console.log("searchCityId", this.searchCityId)
    // console.log("getPropertyType", this.getPropertyType(this.selectedOption))
    // console.log("bedroomselectedOption", this.bedroomselectedOption)
    // console.log("priceLimitselectedOption", this.priceLimitselectedOption)
    // // console.log("tagValues",this.tagValues)
    // console.log("this.selectedTagItems", this.selectedTagItems)
    let queryParams: any = {
      // type_id: '1'
    };

    if (this.selectedTagItems && this.selectedTagItems.length > 0) {
      queryParams.city_id = this.selectedTagItems.join(",")
    }
    if (this.selectedOption) {
      queryParams.property_type = this.getPropertyType(this.selectedOption)
    }
    if (this.bedroomselectedOption) {
      queryParams.no_of_bedrooms = this.bedroomselectedOption
    }
    if (this.priceLimitselectedOption) {
      let price = this.priceLimitselectedOption.replace(" AED", '')
      var number_price = price.replace(/,/g, '');
      // console.log("number_price",number_price)
      queryParams.price_limit = number_price
    }
    if(this.minPrice){
      queryParams.min_price = this.minPrice
    }

    if(this.maxPrice){
      queryParams.max_price = this.maxPrice
    }
    // console.log("selling_type",this.selling_type)
    this.router.navigate(['/properties/' + this.selling_type], { queryParams: queryParams });
  }

  getPropertyType(type: any) {
    let value;
    if (type == 'APARTMENT') {
      value = 1
    } else if (type == 'TOWNHOUSE') {
      value = 3
    } else if (type == 'VILLA') {
      value = 2
    }
    return value
  }

  onAdded(event: any) {
    console.log(event)
    if (!this.selectedTagItems.includes(event.id)) {
      this.selectedTagItems.push(event.id);
    }
  }

  onDelete(event: any) {
    const index = this.selectedTagItems.indexOf(event.id);
    if (index !== -1) {
      this.selectedTagItems.splice(index, 1);
    }
  }

  // onAddTag(tag: any) {
  //   this.items.push(tag);
  // }

  // onRemoveTag(tagToRemove: any) {
  //   this.items = this.items.filter(tag => tag !== tagToRemove);
  // }

  onOpenModal(type_name: any) {
    if (type_name == 'owner_outside_uae') {
      this.contact_type = 2
      setTimeout(() => {
        $('#propertyuaeModalCenter').modal('show');
      });
    }else if(type_name == 'multiple_properties'){
      this.contact_type = 1
      setTimeout(() => {
        $('#propertyModalCenter').modal('show');
      });
    }
  }

  onAssistedPlan(){
    setTimeout(() => {
      $('#devloperModal').modal('show');
    });
  }

  closeAssistedPlan(){
    setTimeout(() => {
      $('#devloperModal').modal('hide');
    });
  }

  closeModal(type_name: any){
    if (type_name == 'owner_outside_uae') {
      setTimeout(() => {
        $('#propertyuaeModalCenter').modal('hide');
        window.location.href = '/'
      });
    }else if(type_name == 'multiple_properties'){
      setTimeout(() => {
        window.location.href = '/'
        $('#propertyModalCenter').modal('hide');
      });
    }
  }

  // async onLocationInputChange(){
  //   let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_LOCATION_DATA, {
  //     "location" : this.inputValue
  //   })
  //   if(res && !res.error && res.data){
  //     this.options = res.data;
  //   }
  // }

  async onLocationInputChange(event : any){
    // console.log(event.target.value)
    // let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_LOCATION_DATA, {
    //   "location" : event.target.value
    // })
    // if(res && !res.error && res.data){
    //   this.options = res.data.map((city: any) => ({ label: city.description, value: city }));
    // }
  }

  requestAutocompleteItems = (text: string): Observable<any> => {
    // Prepare the data for the POST request
    if (this.lastSearch == text) {
      return of(this.lastSearchData);
    } else {
      this.lastSearch = text;
      const data = {
        "location" : text
      };
  
      // Call the 'post' method from your ApiService
      // Note: The URL and other configurations should be handled inside your 'post' method
      return from(this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_LOCATION_DATA, data)).pipe(
        map(response => {
          this.lastSearchData = response;
          // Process the response here
          return response; // Adjust this according to your response structure
        }),
        catchError(error => {
          // Handle the error here
          console.error('Error fetching autocomplete items:', error);
          return throwError(() => new Error('Error fetching autocomplete items'));
        })
      );
    }

  };

  onOptionSelected(option:any){
    console.log("option",option)
  }

  changePropertyType(type : any){
    this.selling_type = type
  }

  onReset(){
    console.log("on reset")
  }

  onClose(){
    console.log("on close")
  }

  onLoginClose(e: any) {
    console.log("close calling");
    this.shared.fromButtonLogin = false;
  }

  onSellProperty() {
    console.log("on click");
    console.log("this.shared.isUserLoggedIn", this.shared.isUserLoggedIn);

    if (this.shared.isUserLoggedIn) {
      // this.router.navigate(['/create-property']);
      window.location.href = '/create-property'
    } else {
      this.shared.fromButtonLogin = true;
    }
    // console.log("this.fromButtonLogin",this.fromButtonLogin)
  }

  async getData() {
    const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_DEVELOPER, {});
    if (res && !res.error && res.data) {
      this.developerData = res.data; // Assuming res.data is an array of developers
    }

    const resData = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_REVIEWS, {});
    if (resData && !resData.error && resData.data) {
      this.reviewData = resData.data; // Assuming res.data is an array of developers
    }
  }

  redirectProperty(s:any) {
    window.location.href = "/developer-view/" + s.developer_id + "/" + this.shared.generateUrlSlug(s.developer_name);
  }

  redirectReview(review_id: number) {
    window.location.href = "/reviews-view/" + review_id;
  }
}
